(() => {
  const article = document.querySelector('[data-bugass-article]');
  const body = article?.querySelector('[data-article-body]');
  const desktopToc = article?.querySelector('[data-toc-desktop]');
  const mobileToc = article?.querySelector('[data-toc-mobile]');

  if (!article || !body || !desktopToc || !mobileToc) return;

  const headings = Array.from(body.querySelectorAll('h2, h3'));
  if (headings.length < 3) return;

  const usedIds = new Set();
  const slugify = (value) => {
    const normalized = value
      .toLocaleLowerCase('tr-TR')
      .replaceAll('ı', 'i')
      .replaceAll('ğ', 'g')
      .replaceAll('ü', 'u')
      .replaceAll('ş', 's')
      .replaceAll('ö', 'o')
      .replaceAll('ç', 'c')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'bolum';

    let unique = normalized;
    let suffix = 2;
    while (usedIds.has(unique) || document.getElementById(unique)) {
      unique = `${normalized}-${suffix}`;
      suffix += 1;
    }
    usedIds.add(unique);
    return unique;
  };

  headings.forEach((heading) => {
    if (!heading.id) heading.id = slugify(heading.textContent.trim());
  });

  const lists = article.querySelectorAll('[data-toc-list]');
  lists.forEach((list) => {
    const fragment = document.createDocumentFragment();
    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.level = heading.tagName.slice(1);
      item.append(link);
      fragment.append(item);
    });
    list.append(fragment);
  });

  desktopToc.hidden = false;
  mobileToc.hidden = false;

  article.querySelectorAll('[data-toc-count]').forEach((count) => {
    count.textContent = `${headings.length} bölüm`;
  });

  const progress = article.querySelector('[data-toc-progress]');
  const desktopPanel = article.querySelector('[data-toc-panel]');
  const links = Array.from(article.querySelectorAll('[data-toc-list] a'));
  const desktopLinks = Array.from(desktopToc.querySelectorAll('[data-toc-list] a'));
  const setActive = (id) => {
    links.forEach((link) => {
      if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });

    const activeIndex = headings.findIndex((heading) => heading.id === id);
    if (progress && activeIndex >= 0) {
      progress.style.transform = `scaleX(${(activeIndex + 1) / headings.length})`;
    }

    const activeDesktopLink = desktopLinks.find((link) => link.hash === `#${id}`);
    if (desktopPanel && activeDesktopLink) {
      const panelRect = desktopPanel.getBoundingClientRect();
      const linkRect = activeDesktopLink.getBoundingClientRect();
      if (linkRect.top < panelRect.top || linkRect.bottom > panelRect.bottom) {
        desktopPanel.scrollTo({
          top: activeDesktopLink.offsetTop - desktopPanel.clientHeight / 2 + activeDesktopLink.clientHeight / 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }
  };

  const updateActiveHeading = () => {
    const threshold = window.scrollY + Math.min(220, window.innerHeight * 0.28);
    let current = headings[0];
    headings.forEach((heading) => {
      if (heading.getBoundingClientRect().top + window.scrollY <= threshold) current = heading;
    });
    setActive(current.id);
  };

  let frameRequested = false;
  const requestActiveUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(() => {
      updateActiveHeading();
      frameRequested = false;
    });
  };

  updateActiveHeading();
  window.addEventListener('scroll', requestActiveUpdate, { passive: true });
  window.addEventListener('resize', requestActiveUpdate);
  window.addEventListener('hashchange', () => {
    const hashId = decodeURIComponent(window.location.hash.slice(1));
    if (headings.some((heading) => heading.id === hashId)) setActive(hashId);
  });
})();
